import * as React from 'react';
import withStyles from 'react-jss';
import { CssType, ThemeType } from '../../../theming/jssTypes';
import { Modal } from 'src/design-system/components/atoms';
import FixedHeaderTable from 'src/design-system/components/molecules/FixedHeaderTable/FixedHeaderTable';
import { Link } from 'react-router-dom';
import { getDetailsRoute } from '../../../routing/utils';
import { columnsToShowInCustomerReferenceList } from './utils';
import { getConsignmentStatusPrettyName } from '../../../utils/consignmentStatus';
import { withRouter } from 'react-router';

const styles = (theme: ThemeType): CssType => ({
  tableContainer: {
    flex: '1 1 0',
    borderTop: `${theme.border.width.sm} solid ${theme.color.semantic.border.primary}`,
    '& .ant-table-tbody > tr > td, .ant-table-thead > tr > th': {
      padding: theme.spacing[2],
      wordBreak: 'break-word',
    },
  },
  customStyle: {
    border: `${theme.border.width.sm} solid ${theme.color.semantic.border.primary}`,
  },
  customBreak: {
    wordBreak: 'break-all',
  },
  orderTagContainer: {
    minHeight: theme.spacing[4],
    minWidth: '49px',
    textAlign: 'center',
    justifyContent: 'center',
    backgroundColor: theme.color.semantic.background.neutral.subtle,
    fontSize: theme.typography.fontSize.xs,
    fontColor: theme.color.semantic.text.primary,
    border: `${theme.border.width.sm} solid ${theme.color.semantic.accent.orange.strong}`,
    borderRadius: theme.radius.full,
    lineHeight: theme.typography.lineHeight.none,
    margin: theme.spacing[0],
    fontWeight: theme.typography.fontWeight.semibold,
    padding: `${theme.spacing[0]} ${theme.spacing[1]}`,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  iconWrapper: {
    display: 'flex',
    flexFlow: 'wrap',
  },
});

const CustomerReferenceListModal = (props: any) => {
  const { isVisible, classes, data, viewType, onModalClose, columns: customColumns } = props;
  const renderOrderTag = (text = '') => {
    return (
      <div className={classes.orderTagContainer}>{text.toUpperCase()}</div>
    );
  };
  const columnsToRender = columnsToShowInCustomerReferenceList({ columns: customColumns });
  const columns =
    columnsToRender &&
    columnsToRender.map((col) => {
      return {
        dataIndex: col.column_id,
        title: col.pretty_name,
        width: 170,
        render: (x, record, index) => {
          switch (col.column_id) {
            case 'pos_order_number_ondemand':
            case 'order_number':
            case 'reference_number':
              return (
                <Link
                  target={viewType === 'ondemand' ? null : '_blank'}
                  to={{
                    pathname: getDetailsRoute(
                      encodeURIComponent(record.reference_number),
                    ),
                    state: { viewType },
                  }}
                >
                  <span className={classes.customBreak}>{x}</span>
                </Link>
              );
            case 'status':
              return getConsignmentStatusPrettyName(x.toLowerCase());
            case 'ondemand_order_tags':
              return (
                <div className={classes.iconWrapper}>
                  {x?.length ? x.map((tag) => renderOrderTag(tag)) : null}
                </div>
              );
            default:
              return <span className={classes.customBreak}>{x}</span>;
          }
        },
      };
    });
  
  // Calculate total width needed for all columns
  const totalColumnWidth = columns ? columns.length * 170 : 1000;
  
  return (
    <Modal
      title={'Consignments'}
      visible={isVisible}
      width={1000}
      cancelText={'Close'}
      onCancel={() => onModalClose()}
      maskClosable={false}
      okButtonProps={{ style: { display: 'none' } }}
      destroyOnClose
    >
      <div className={classes.tableContainer}>
        <FixedHeaderTable
          bordered
          className={classes.customStyle}
          locale={{ emptyText: 'No consignments found' }}
          dataSource={data}
          pagination={false}
          columns={columns}
          scroll={{ x: totalColumnWidth, y: 300 }}
          minHeight={300}
        />
      </div>
    </Modal>
  );
};
const CustomerReferenceListModalStyled: any = withStyles(styles, {
  injectTheme: true,
})(CustomerReferenceListModal);
export default withRouter(
  CustomerReferenceListModalStyled,
) as React.ComponentType<any>;
